import { render, staticRenderFns } from "./payTable.vue?vue&type=template&id=2cd49f4a&scoped=true&"
import script from "./payTable.vue?vue&type=script&lang=js&"
export * from "./payTable.vue?vue&type=script&lang=js&"
import style0 from "./payTable.vue?vue&type=style&index=0&id=2cd49f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd49f4a",
  null
  
)

export default component.exports